/* PDP "Choose Your Pack" selector.
   Owns no CTA of its own — the selection drives every Add to Cart that carries
   the pack hooks: the sticky bar (snippets/custom-floating-addtocart.liquid)
   and the inline buy button (snippets/product-form.liquid). Each has a
   [data-pack-qty] quantity input and a [data-pack-atc-label]; the sticky bar
   also has the pack price block. Config comes from window.PHD_PACK_OF_2,
   emitted by snippets/custom-pack-selector.liquid.

   Hooks are looked up on every apply, never cached: a variant change re-renders
   the inline button from the server, which would leave a cached node detached.

   cfg.autoCode holds the linked offer's discount code, applied for the shopper
   as soon as the pack lands in the cart. It is empty when the linked offer is
   an automatic discount — those have no code, and Shopify alone decides which
   automatic discount a cart gets.
 */
(function () {
  'use strict';

  function init() {
    var cfg = window.PHD_PACK_OF_2;
    if (!cfg) return;

    var root = document.querySelector('[data-pack-selector]');
    if (!root) return;

    var inputs = root.querySelectorAll('.phd-pack__radio-input');
    if (!inputs.length) return;

    var bar = document.getElementById('floating-addtocart-' + cfg.productId);
    var priceBlock = bar ? bar.querySelector('[data-pack-price-block]') : null;
    var priceNow = bar ? bar.querySelector('[data-pack-price-now]') : null;
    var priceWas = bar ? bar.querySelector('[data-pack-price-was]') : null;

    var syncPrice = cfg.syncSticky !== false && bar && priceBlock && priceNow && priceWas;

    // var carryCode=!!cfg.autoCode;   // only fed the stale warning below


    function each(selector, fn) {
      var nodes = document.querySelectorAll(selector);
      for (var n = 0; n < nodes.length; n++) fn(nodes[n]);
    }

    if (!document.querySelector('[data-pack-qty]')) {
      root.hidden = true;
      try { console.warn('[pack] no Add to Cart quantity input for ' + cfg.productId + ' — selector hidden.'); } catch (e) {}
      return;
    }

    /* The reconcile that used to own this lives commented out in
       assets/custom.js. Applying the code is now done here, from cfg.autoCode,
       so nothing has to be declared to another file first. */
    // if(window.PHD_PACK){
    //   window.PHD_PACK.declare(cfg.productId, cfg.autoCode, cfg.packQty);
    // }else if(carryCode){
    //   try{
    //     console.warn('[pack] phd-pack-discount.js is not loaded — the pack code will not be applied.')
    //   }catch(e){}
    // }

    function getCart(){
    return fetch('/cart.js',{ credentials: 'same-origin' })
    .then(function(r){
        return r.json();
    })
}

    function cartCodes(cart) {
      var out = [];
      var codes = (cart && cart.discount_codes) || [];
      for (var i = 0; i < codes.length; i++) {
        if (codes[i] && codes[i].code ) out.push(codes[i].code);
      }
      return out;
    }

    function includesCode(list, code) {
      var want = String(code).toUpperCase();
      for (var i = 0; i < list.length; i++) {
        if (String(list[i]).toUpperCase() === want) return true;
      }
      return false;
    }


    function publishSelectionAdd(isPack, added) {
      if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) return;
      Shopify.analytics.publish(isPack ? 'pg_pack_atc' : 'pg_single_atc', {
        pack_product: String(cfg.productId),
        pack_variant: String(added.id || ''),
        pack_selection: isPack ? 'pack' : 'single',
        pack_qty: cfg.packQty,
        added_qty: added.quantity || 0,
        pack_code: isPack ? (cfg.autoCode || '') : '',
        has_code: cfg.autoCode ? '1' : '0'
      });
    }

 
    function publishPackCodeResult(status) {
      if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) return;
      Shopify.analytics.publish('pg_pack_code_result', {
        pack_product: String(cfg.productId),
        pack_code: cfg.autoCode,
        pack_status: status
      });
    }

    function applyPackCode() {
      if (!cfg.autoCode) return;

        getCart()
        .then(function (cart) {
          var codes = cartCodes(cart);
          /* Already on — a second pack add needs no write at all. */
          if (includesCode(codes, cfg.autoCode)) return null;

          codes.push(cfg.autoCode);

          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ discount: codes.join(',') })
          }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) {
            publishPackCodeResult('already_applied');
            return;
          }

          var stuck = includesCode(cartCodes(cart), cfg.autoCode);

          /* A code Shopify declined comes back as a normal 200 — without this
             the shopper is quietly charged full price and nothing says so. */
          if (!stuck) {
            try {
              console.warn('[pack] ' + cfg.autoCode + ' did not stick — the cart is charging full price.');
            } catch (e) {}
          }
          publishPackCodeResult(stuck ? 'applied' : 'rejected');

          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true, detail: { cart: cart, source: 'phd-pack' }
          }));
        })

        .catch(function (err) {
          try {
            console.warn('[pack] could not apply ' + cfg.autoCode + ' — the cart will charge full price.', err);
          } catch (e) {}
        });
    }

    function paintCards() {
      for (var i = 0; i < inputs.length; i++) {
        var card = inputs[i].closest('.phd-pack__card');
        if (card) card.classList.toggle('is-selected', inputs[i].checked);
      }
    }

    function apply(isPack){
      root.classList.toggle('phd-pack--pack',isPack);
      paintCards();

      each('[data-pack-qty]', function (input) {
        input.value = isPack ? cfg.packQty : 1;

        /* A pack always goes in through the button. pack-mode keeps the stepper
           wrapping this form (sticky bar, inline buy button) on its add to cart
           button even when the product is already in the cart — see
           assets/custom-card-qty-stepper.css. */
        var stepper = input.closest('card-qty-stepper');
        if (stepper) stepper.toggleAttribute('pack-mode', isPack);
      });
      each('[data-pack-atc-label]', function (label) { label.textContent = isPack ? cfg.labels.pack : cfg.labels.single; });

      if (syncPrice) {
        priceNow.textContent = cfg.prices.pack;
        priceWas.textContent = cfg.prices.compare;
        bar.classList.toggle('is-pack', isPack);
      }
    }
    function selected() {
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].checked) return inputs[i].value === 'pack';
      }
      return false;
    }

    for (var i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('change', function () {
        apply(selected());
      });
    }

    /* A variant switch changes the unit price, which invalidates every figure
       rendered above. Fall back to the single unit rather than carrying a stale
       pack price into the cart. */
    document.documentElement.addEventListener('variant:changed', function () {
      var single = root.querySelector('.phd-pack__radio-input[value="single"]');
      if (single && !single.checked) {
        single.checked = true;
        apply(false);
      }
    });

    /* Any form carrying the pack quantity hook — the sticky bar or the inline
       buy button. Other product forms on the page (quick-buy, upsells) don't. */
    document.documentElement.addEventListener('variant:added', function (event) {
      var form = event.target;
      if (!form || !form.querySelector || !form.querySelector('[data-pack-qty]')) return;

      /* The radio is the only record of intent — nothing in the submitted form
         says which arm this was, now that the add carries no properties. */
      var isPack = selected();

      publishSelectionAdd(isPack, (event.detail && event.detail.variant) || {});

      /* Single needs nothing further — no code is applied to a one-unit add. */
      if (!isPack) return;

      applyPackCode();
    });

    apply(selected());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
